import axios from 'axios';
import history from '@/historys';
import store from '@/store';
import { API_BASE_URL } from '@/utils/constants';
import { _loaded } from '@/actions/commonAction';
import { _updateEmpNo } from '@/actions/mainAction';
import { toast } from 'react-toastify';

// axios default setting
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.timeout = 30000;
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status === 403) {
    store.dispatch(_updateEmpNo(''))
    store.dispatch(_loaded())
    toast.error("권한 받으세요.")
    return Promise.reject(error);
  } else if (error.response && error.response.status === 400) {
    store.dispatch(_loaded())
    toast.error("입력 값이 유효하지 않습니다.")
    return Promise.reject(error);
  } else {
    // Set API Error Page URI
    history.push('/errorpage');
    store.dispatch(_loaded())
    return Promise.reject(error);
  }
});



// WEBPACK FOOTER //
// ./src/config.js